/**
 * Which environment this build serves, read from Vite's build mode.
 *
 * The deploy builds each environment with its own mode (`build:staging`, `build:production`), and
 * the end-to-end tier builds with `test`, so the mode already names the environment and no new
 * variable is needed. Anything else — `vite` in development — is development.
 *
 * The frame says it in two places (Brand Kit § The frame): the footer, always, and the rail, only
 * outside production, where a write to staging must never look like one to production.
 */
export type Environment = 'production' | 'staging' | 'test' | 'development';

export function currentEnvironment(mode: string = import.meta.env.MODE): Environment {
  return mode === 'production' || mode === 'staging' || mode === 'test' ? mode : 'development';
}

/** The `shell` translation key that names each environment. */
export const ENVIRONMENT_LABEL_KEY = {
  production: 'env.production',
  staging: 'env.staging',
  test: 'env.test',
  development: 'env.development',
} as const satisfies Record<Environment, string>;
